"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var primary = _ref.palette.primary;
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#F7F7F7',
      fontSize: '12px',
      lineHeight: 1.5,
      letterSpacing: 0,
      padding: '6px 12px',
      borderRadius: 50
    },
    clickable: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#EBEBEB'
      }
    },
    icon: {
      backgroundColor: '#ADADAD',
      borderRadius: '50%',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: -8,
      marginRight: 12,
      color: '#fff'
    },
    removeBtn: {
      cursor: 'pointer',
      marginLeft: 12,
      marginRight: -8
    },
    selected: {
      color: primary.main,
      backgroundColor: (0, _styles.emphasize)(primary.main, 0.8),
      '&:hover': {
        backgroundColor: (0, _styles.emphasize)(primary.main, 0.8)
      },
      '& $icon': {
        backgroundColor: primary.main
      }
    },
    size: {
      '&-md': {
        minHeight: 32,
        '& $icon': {
          width: 24,
          height: 24
        }
      },
      '&-lg': {
        minHeight: 50,
        '& $icon': {
          width: 34,
          height: 34
        }
      }
    }
  };
}, {
  name: 'Chip'
});
exports.useStyles = useStyles;